import React, { useState } from 'react';
import { MdDashboard, MdBarChart, MdCloudUpload, MdVideoLibrary,
  MdSchedule, MdTrendingUp, MdAutoStories, MdAutoAwesome,
  MdStar, MdShield, MdLogout, MdChevronLeft, MdChevronRight,
  MdAdminPanelSettings } from 'react-icons/md';

const navItems = [
  { id: 'dashboard', icon: <MdDashboard />, label: 'Dashboard' },
  { id: 'channels', icon: <MdBarChart />, label: 'Platform Manager' },
  { id: 'upload', icon: <MdCloudUpload />, label: 'Upload Video' },
  { id: 'library', icon: <MdVideoLibrary />, label: 'Video Library' },
  { id: 'schedules', icon: <MdSchedule />, label: 'Schedule' },
  { id: 'analytics', icon: <MdTrendingUp />, label: 'Analytics' },
  { id: 'growth', icon: <MdAutoStories />, label: 'ChannelForge', isNew: true },
  { id: 'contentforge', icon: <MdAutoAwesome />, label: 'ContentForge', isNew: true },
  { id: 'channel_videos', icon: <MdVideoLibrary />, label: 'Channel Videos', isNew: true },
  { id: 'scorer', icon: <MdStar />, label: 'ObsidianEye', isNew: true },
  { id: 'guardian', icon: <MdShield />, label: 'GuardianAI', isNew: true },
  { id: 'obsidian', icon: <MdAutoAwesome />, label: 'Obsidian AI', isAI: true },
  { id: 'admin', icon: <MdAdminPanelSettings />, label: 'Admin Panel', isAdmin: true }
];

export default function Sidebar({ activePage, setActivePage, user, onLogout, hasAccess }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div style={{
      width: isOpen ? '240px' : '64px',
      minHeight: '100vh',
      background: 'var(--bg-card)',
      borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column',
      transition: 'width 0.3s ease',
      flexShrink: 0, position: 'relative', zIndex: 100
    }}>
      {/* Logo */}
      <div style={{
        padding: '20px 16px',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center',
        justifyContent: isOpen ? 'space-between' : 'center',
        gap: '10px'
      }}>
        {isOpen && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img src="/logo.png" alt="Vantage" style={{ width: '32px', height: '32px', borderRadius: '8px', objectFit: 'contain' }} />
            <span style={{ fontWeight: '800', fontSize: '18px', color: 'var(--text-primary)' }}>Vantage</span>
          </div>
        )}
        {!isOpen && (
          <img src="/logo.png" alt="Vantage" style={{ width: '32px', height: '32px', borderRadius: '8px', objectFit: 'contain' }} />
        )}
        <button onClick={() => setIsOpen(!isOpen)} style={{
          background: 'var(--bg-dark)', border: '1px solid var(--border)',
          color: 'var(--text-secondary)', width: '24px', height: '24px',
          borderRadius: '50%', cursor: 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center', fontSize: '14px', flexShrink: 0
        }}>
          {isOpen ? <MdChevronLeft /> : <MdChevronRight />}
        </button>
      </div>

      {/* User Info */}
      {isOpen && user && (
        <div style={{
          padding: '12px 16px', borderBottom: '1px solid var(--border)',
          background: 'rgba(0,200,83,0.04)'
        }}>
          <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '2px' }}>
            {user.name}
          </div>
          <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>{user.email}</div>
          <div style={{ marginTop: '6px' }}>
            <span style={{ fontSize: '10px', fontWeight: '700', padding: '2px 8px', borderRadius: '10px', textTransform: 'capitalize', background: 'rgba(0,200,83,0.15)', color: 'var(--primary)' }}>
              {user.subscription_tier || 'No Plan'}
            </span>
          </div>
        </div>
      )}

      {/* Nav Items */}
      <nav style={{ flex: 1, padding: '12px 8px', overflowY: 'auto' }}>
        {navItems.map(item => {
          if (item.isAdmin && !user?.is_admin) return null;
          const isActive = activePage === item.id;
          const isLocked = !hasAccess(item.id) && !user?.is_admin && !item.isAdmin;

          return (
            <div key={item.id}
              onClick={() => !isLocked && setActivePage(item.id)}
              title={!isOpen ? item.label : ''}
              style={{
                display: 'flex', alignItems: 'center', gap: '10px',
                padding: '10px 12px', borderRadius: '10px', marginBottom: '4px',
                cursor: isLocked ? 'not-allowed' : 'pointer',
                background: isActive ? 'rgba(0,200,83,0.12)' : 'transparent',
                border: '1px solid ' + (isActive ? 'rgba(0,200,83,0.3)' : 'transparent'),
                color: isActive ? 'var(--primary)' : isLocked ? 'var(--text-light)' : 'var(--text-secondary)',
                transition: 'all 0.2s ease',
                opacity: isLocked ? 0.4 : 1,
                justifyContent: isOpen ? 'flex-start' : 'center'
              }}
              onMouseEnter={e => { if (!isLocked && !isActive) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
              onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}>
              <span style={{ fontSize: '18px', flexShrink: 0 }}>{item.icon}</span>
              {isOpen && (
                <>
                  <span style={{ fontSize: '13px', fontWeight: '600', flex: 1 }}>{item.label}</span>
                  {item.isAI && <span style={{ fontSize: '9px', fontWeight: '800', padding: '2px 6px', borderRadius: '6px', background: 'var(--primary-gradient)', color: 'white' }}>AI</span>}
                  {item.isNew && <span style={{ fontSize: '9px', fontWeight: '800', padding: '2px 6px', borderRadius: '6px', background: 'rgba(0,188,212,0.2)', color: '#00bcd4' }}>NEW</span>}
                  {item.isAdmin && <span style={{ fontSize: '9px', fontWeight: '800', padding: '2px 6px', borderRadius: '6px', background: 'rgba(245,0,87,0.2)', color: '#f50057' }}>ADMIN</span>}
                  {isLocked && <span style={{ fontSize: '12px' }}>🔒</span>}
                </>
              )}
            </div>
          );
        })}
      </nav>

      {/* Logout */}
      <div style={{ padding: '12px 8px', borderTop: '1px solid var(--border)' }}>
        <div onClick={onLogout} style={{
          display: 'flex', alignItems: 'center', gap: '10px',
          padding: '10px 12px', borderRadius: '10px', cursor: 'pointer',
          color: '#ef4444', transition: 'all 0.2s ease',
          justifyContent: isOpen ? 'flex-start' : 'center'
        }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.08)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
          <MdLogout style={{ fontSize: '18px', flexShrink: 0 }} />
          {isOpen && <span style={{ fontSize: '13px', fontWeight: '600' }}>Logout</span>}
        </div>
      </div>
    </div>
  );
}